import GoodsTracking from "@/pages/scts/GoodsTracking"
import GoodsTrackingMap from "@/pages/scts/GoodsTrackingMap"
import Index from "@/pages/scts/Index"
import Search from "@/pages/scts/Search"
import Th from "@/pages/scts/th/Index"
import ThOrder from "@/pages/scts/th/Order"
import ThGoods from "@/pages/scts/th/Goods"
import ThTrans from "@/pages/scts/th/Trans"
import ThFiles from "@/pages/scts/th/Files"
import Sh from "@/pages/scts/sh/Index"
import ShOrder from "@/pages/scts/sh/Order"
import ShGoods from "@/pages/scts/sh/Goods"
import ShTrans from "@/pages/scts/sh/Trans"
import ShFiles from "@/pages/scts/sh/Files"
import Thd from "@/pages/scts/Thd"
import Psd from "@/pages/scts/Psd"
import Abnormal from "@/pages/scts/Abnormal"

let router = [{
    path: "/scts/goods_tracking",
    name: "goods_tracking",
    component: GoodsTracking,
    meta: {
      title: "货物跟踪",
      keepAlive: true,
      login: false // 是否需要登录
    }
  }, {
    path: "/scts/tracking_map",
    name: "tracking_map",
    component: GoodsTrackingMap,
    meta: {
      title: "运输轨迹",
      keepAlive: true,
      login: false // 是否需要登录
    }
  }, {
    path: "/scts/",
    name: "Index",
    component: Index,
    meta: {
      title: "TMS运输管理系统",
      keepAlive: true
    }
  }, {
    path: "/scts/thd",
    name: "thd",
    component: Thd,
    meta: {
      title: "提货单",
      role: [0]
    }
  }, {
    path: "/scts/psd",
    name: "psd",
    component: Psd,
    meta: {
      title: "送货单",
      role: [0]
    }
  }, {
    path: "/scts/search",
    name: "search",
    component: Search,
    meta: {
      title: "搜索"
    }
  }, {
    path: "/scts/th",
    name: "th",
    component: Th,
    meta: {
      title: "提货单"
    },
    children: [{
      path: "/scts/th/order",
      name: "order",
      component: ThOrder,
      meta: {
        title: "提货单信息"
      },
    }, {
      path: "/scts/th/goods",
      name: "goods",
      component: ThGoods,
      meta: {
        title: "货物"
      },
    }, {
      path: "/scts/th/trans",
      name: "trans",
      component: ThTrans,
      meta: {
        title: "物流"
      },
    }, {
      path: "/scts/th/files",
      name: "files",
      component: ThFiles,
      meta: {
        title: "回单"
      },
    }]
  }, {
    path: "/scts/sh",
    name: "sh",
    component: Sh,
    meta: {
      title: "送货单"
    },
    children: [{
      path: "/scts/sh/order",
      name: "order",
      component: ShOrder,
      meta: {
        title: "送货单信息"
      },
    }, {
      path: "/scts/sh/goods",
      name: "goods",
      component: ShGoods,
      meta: {
        title: "货物"
      },
    }, {
      path: "/scts/sh/trans",
      name: "trans",
      component: ShTrans,
      meta: {
        title: "物流"
      },
    }, {
      path: "/scts/sh/files",
      name: "files",
      component: ShFiles,
      meta: {
        title: "回单"
      },
    }]
  },
  {
    path: "/scts/abnormal",
    name: "abnormal",
    component: Abnormal,
    meta: {
      title: "异常反馈",
      role: [0]
    }
  }
];
export default router;



// WEBPACK FOOTER //
// ./src/router/scts.js